module.exports = __webpack_public_path__ + "bbcae70093f25c4d2bfc763be3e54cc5.fbx";